var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.paymentTypeItems,"label":_vm.label,"outlined":_vm.outlined,"dense":_vm.dense,"rules":_vm.rules,"disabled":_vm.disabled},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.$t(("product.payment_type." + item))))])]}},{key:"item",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.$t(("product.payment_type." + item))))])]}}]),model:{value:(_vm.paymentType),callback:function ($$v) {_vm.paymentType=$$v},expression:"paymentType"}})}
var staticRenderFns = []

export { render, staticRenderFns }